import { useState } from "react";
import { useForm } from "react-hook-form";
import { updateAddressRoute } from "@api-routes/contacts";
import { EADDRESS_TYPES, MERGE_PATCH_HEADER } from "@constants";
import { getStateToPayload, IUserAddressPayload } from "../mappers/updateUserAddressMapper";
import { useUserContext } from "@hook/useUserContext";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";
import { useFetch } from "@common/hook/useFetch";

export const useBillingAddress = (billingAddress?: IUserAddress) => {
    const [isEditing, setIsEditing] = useState(false);
    const [hasSameDeliveryAddress, setHasSameDeliveryAddress] = useState(false);
    const { username: contactUuid } = useUserContext();

    const [updateUserAddressState, { patch }] = useFetch();

    const formMethods = useForm<IUserAddress>({ defaultValues: billingAddress });

    const updateAddress = (address: IUserAddressPayload) => {
        if (contactUuid) {
            patch<boolean>(updateAddressRoute(contactUuid), {
                body: address,
                headers: MERGE_PATCH_HEADER,
            }).then((updateAddressResponse) => {
                if (updateAddressResponse) {
                    setIsEditing(false);
                }
            });
        }
    };

    const submitUserAddress = formMethods.handleSubmit((formData) => {
        const newBillingAddress = getStateToPayload(formData);

        updateAddress(newBillingAddress);

        if (hasSameDeliveryAddress) {
            const deliveryAddress = { ...newBillingAddress, type: EADDRESS_TYPES.DELIVERY };
            updateAddress(deliveryAddress);
        }
    });

    return {
        formMethods,
        editing: { isEditing, setIsEditing },
        sameAddress: { hasSameDeliveryAddress, setHasSameDeliveryAddress },
        submitUserAddress,
        updateUserAddressState,
    };
};
